/* unplugin-vue-components disabled */import script from "./PlayerLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayerLink.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__